import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';
import { setBehaviourEvent as setFunnelyticsBehaviourEvent } from '../funnelytic_analytics/funnelytics_interface';

class CheckoutConfiguratorAnalytics {
    // For reference: https://tyroola.atlassian.net/wiki/spaces/TKB/pages/2492006434/Vehicle+Configurator+Event+names+for+Checkout+page+and+other+pages
    static getGAPrefix() {
        return location.href.indexOf('/checkout/') !== -1 ? 'configurator_co_' : 'configurator_';
    }
    
    static openRegoLookupAction() {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.vehicleCheckoutLightboxShow;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
    
    static selectStateInRegoLookupAction(labelParam) {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.selectState;
        const label = labelParam || '';

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
    
    static setRegistrationInRegoLookupAction(labelParam) {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.setRegistration;
        const label = labelParam || '';

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
    
    static customerSubmittedContinueRegoLookupAction() {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.continueClicked;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
    
    static customerSubmittedSelectVehicleRegoLookupAction() {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.selectVehicleClicked;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
    
    static customerClickedSearchByVehicleAction() {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.alternativeLinkSearchByVehicleClicked;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
    
    static customerClickedSearchByRegoLookupAction() {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.alternativeLinkSearchByRegoLookupClicked;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
    
    static cannotProvideVehicleLinkClickAction() {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.sorryICantProvideVehicleLinkClicked;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
    
    static cannotProvideVehicleSubmittedClickAction(labelParam) {
        const category = GA_EVENTS.checkoutConfigurator.category;
        const action = this.getGAPrefix() + GA_EVENTS.checkoutConfigurator.actions.iCantProvideVehicleSubmitClicked;
        const label = labelParam || '';

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }
}

export default CheckoutConfiguratorAnalytics;